import React from 'react'
import Layout from "../components/Layout";
import SectionHeading from "../components/SectionHeading";
import CommonBanner from '../components/CommonBanner';

function CookiesPolicy() {
  return (
    <Layout>
      <CommonBanner title="Cookies Policy" />
      <div className='privacy-policy'>
        <SectionHeading title="Cookies Policy" />
        <p>This Cookies Policy explains how we use cookies and similar tracking technologies on our website.</p>
        <h5>What Are Cookies?</h5>
        <p>Cookies are small text files placed on your device by websites that you visit. They are widely used to make websites work more efficiently and to provide information to website owners for improving user experience.</p>
        <h5>How We Use Cookies</h5>
        <p>Our website uses cookies primarily to:</p>
        <ul>
          <li><strong>Improve Website Performance: </strong>By understanding how visitors use our website, we can optimize the layout and functionality.</li>
          <li><strong>Enhance User Experience: </strong>Cookies help us remember your preferences, so you have a more consistent browsing experience.</li>
        </ul>
        <p>We do not use cookies for targeted advertising, marketing, or to track personal information.</p>
        <h5>Types of Cookies We Use</h5>
        <ol>
          <li><strong>Necessary Cookies: </strong>These cookies are essential for the website to function properly, such as page navigation and access to secure areas.</li>
          <li><strong>Analytics Cookies: </strong>These cookies allow us to analyze website traffic and see how visitors interact with different pages to improve website functionality. We only use aggregated, non-personally identifiable data for this purpose.</li>
        </ol>
        <h5>How to Manage Cookies</h5>
        <p>You can manage your cookie preferences by adjusting your browser settings:</p>
        <ul>
          <li><strong>Disable Cookies: </strong>Most web browsers allow you to disable cookies. However, please note that disabling cookies may affect the functionality of our website.</li>
          <li><strong>Delete Cookies: </strong>You can also delete cookies that have already been stored on your device.</li>
        </ul>
        <p>For more detailed instructions on managing cookies, you can visit your browser’s help documentation.</p>
        <h5>Changes to This Cookies Policy</h5>
        <p>We may update this Cookies Policy from time to time. Any changes will be posted on this page with an updated revision date.</p>
      </div>
    </Layout>
  )
}

export default CookiesPolicy